import moment from "moment";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddOnCalculate from "../../utils/AddOn";
import { CheckIsMeal } from "../../utils/CustomizedCalculation/MealPrice";
import { ItemSizeNameForOrder } from "../../utils/ItemSizeName";
import ParseFloat from "../../utils/ParseFloat";
import { dateFormatOrderPlace } from "../../utils/helper";
import {
  orderMealItemVariationSize,
  ReturnDeliveryAndPickup,
  ReturnPickupAndDeliveryAddress,
  ReturnPriceAndFree,
  TotalPriceOfMealItem,
} from "../../utils/orderUtils/OrderUtils";
import OrderStoreInfo from "./OrderStoreInfo";
import useSelectedStore from "../../hooks/useSelectedStore";
export default function OrderDetail() {
  const navigate = useNavigate();
  const { orderDetail } = useSelector((state: any) => state?.allOrder);
  const { platformFee } = useSelectedStore()
  const { t } = useTranslation();
  useEffect(() => {
    if (!orderDetail || Object.keys(orderDetail).length === 0) {
      navigate("/my-order"); // Redirect if orderDetail is empty or undefined
    }
  }, []);

  const _orderDetailstoreData = useMemo(() => {
    return orderDetail?.store_data;
  }, [orderDetail]);

  const ReturnItemOptions = (order_item_step: any) => {
    return (
      <>
        {order_item_step?.map((stepIt: any, stepIndex: number) => {
          return (
            <div key={stepIndex} className="flexBox justifyBetween">
              <div className="sizeDetail fs-7">
                <span className="flex items-center gap-2 md:text-lg textMd font-normal capitalize">
                  <i className="fa fa-circle text-[5px]"></i>
                  {stepIt?.option_title}
                  <span className="text-gray-600">
                    {" "}
                    {ReturnPriceAndFree(
                      stepIt?.web_price ? stepIt?.web_price : stepIt?.price
                    )}
                  </span>
                </span>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const ReturnItemSubCategory = (order_item_sub_categories: any) => {
    return (
      <>
        {order_item_sub_categories?.map((step: any, index: any) => {
          // console.log("STEPstep", step);
          return (
            <div key={index} className="flexBox justifyBetween">
              <div className="">
                <span className="flex items-center gap-2 md:text-lg textMd font-normal capitalize">
                  {" "}
                  <i className="fa fa-circle text-[5px]"></i> {step?.name}{" "}
                  <span className="text-gray-600">
                    {" "}
                    {ReturnPriceAndFree(
                      step?.web_price ? step?.web_price : step?.price
                    )}
                  </span>
                </span>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const ReturnAddOnData = (addon_data: any) => {
    return (
      <>
        {addon_data?.map((addOnIt: any, index: any) => {
          return (
            <div key={index} className="flexBox justifyBetween">
              <div className="">
                <div className="flex items-center gap-2 md:text-lg textMd font-normal capitalize">
                  <i className="fa fa-circle text-[5px]"></i>{" "}
                  {addOnIt?.item_name}
                  <span className="text-gray-600">
                    {" "}
                    {ReturnPriceAndFree(addOnIt?.price)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  // console.log(orderDetail,"orderDetail")

  // Konsole.log("orderDetailorderDetail", orderDetail, orderDetail?.orderlist);
  return (
    <>
      <div className="md:border border-[#D7D7D7] md:rounded-xl overflow-hidden md:mb-3 mb-24">
        <div className="md:bg-[#F8F8F8] py-2 px-4">
          <OrderStoreInfo
            orderDetail={orderDetail}
            refrencePage="OrderDetail"
          />
        </div>

        <div className="flex md:justify-between py-2 px-4 md:flex-row flex-col gap-4">
          {
            <div className="">
              {/* @@ Delivery And pickup type */}
              <p className="font-bold md:text-lg textMd">
                {ReturnDeliveryAndPickup(orderDetail)}
              </p>
              {/* @@Pickup and Delivery Address */}
              <p className="font-normal md:text-lg textMd">
                {ReturnPickupAndDeliveryAddress(orderDetail)}
              </p>
            </div>
          }

          <div className="md:text-right">
            <p className="font-bold md:text-lg textMd">
              {t("MyOrders.paymentMode")}:
            </p>
            <p className="md:text-lg textMd font-normal">
              {orderDetail?.payment_method}
            </p>
            {/* <p className="font-bold text-lg">Mobile no.</p>
            <p className="text-lg font-normal">{_orderDetailstoreData?.[0]?.phone_number}</p> */}
          </div>
        </div>
        <div className="flex md:justify-between justify-start py-2 px-4 flex-wrap gap-4">
          <div>
            <p className="md:text-lg textMd ">
              <span className="font-bold">{t("MyOrders.orderPlace")}:</span>{" "}
              {moment(orderDetail?.updated_at).format("lll")}
              {dateFormatOrderPlace(orderDetail)?.schedule == true && (
                <>
                  <br />
                  <span className="font-bold">
                    {t("MyOrders.orderSchedule")}:
                  </span>{" "}
                  {dateFormatOrderPlace(orderDetail)?.date}
                </>
              )}
            </p>
            {/* {orderDetail?.order_id && <p className="md:text-lg textMd " >
              <span className="font-bold">{t("MyOrders.orderID")}:</span>{" "}{getOrderId(orderDetail?.order_id)?.split(" ")[1]}
            </p>} */}
            {[1, 3].includes(orderDetail?.order_category) && (
              <p className="md:text-lg textMd ">
                <span className="font-bold">{t("MyOrders.orderType")}:</span>{" "}
                {orderDetail?.order_category == 1
                  ? t("Checkout.pickup")
                  : orderDetail?.order_category == 3
                    ? t("Checkout.delivery")
                    : ""}
              </p>
            )}
            {/* <p className="md:text-lg textMd " >
              <span className="font-bold">{t("MyOrders.scheduledTime")}:</span>
            </p> */}
            {orderDetail?.order_comments && (
              <p className="md:text-lg textMd ">
                <span className="font-bold">
                  {t("MyOrders.deliveryInstructions")}:
                </span>{" "}
                {orderDetail?.order_comments}
              </p>
            )}
            {orderDetail?.order_note && (
              <p className="md:text-lg textMd ">
                <span className="font-bold">{t("MyOrders.order_note")}:</span>{" "}
                {orderDetail?.order_note}
              </p>
            )}
          </div>
          {_orderDetailstoreData &&
            _orderDetailstoreData?.length > 0 &&
            _orderDetailstoreData[0]?.phone_number ? (
            <>
              <button className="h-12 bg-[#34558B] textMd md:w-auto w-full justify-center text-white px-2 py-1 flex gap-2 items-center">
                <i className="fa fa-phone text-3xl"></i>
                <div>
                  <p className="font-bold">{t("MyOrders.callRestaurant")}</p>
                  <p className="font-normal">
                    {_orderDetailstoreData[0]?.country_code
                      ? _orderDetailstoreData[0]?.country_code
                      : null}{" "}
                    {_orderDetailstoreData[0]?.phone_number}
                  </p>
                </div>
              </button>
            </>
          ) : null}
        </div>

        <div className="grid grid-cols-3 bg-[#F8F8F8]  md:text-base text-sm py-2 px-4">
          <p>{t("CartDetails.items")}</p>
          <p className="text-center">{t("MyOrders.qty")}</p>
          <p className="text-right">{t("MyOrders.amount")}</p>
        </div>

        {orderDetail?.orderlist?.map((item: any) => {
          let itemPrice = 0;

          if (CheckIsMeal(item?.is_meal)) {
            itemPrice = item?.price;
            if (item?.map_order_meal_items?.length > 0) {
              itemPrice += TotalPriceOfMealItem(
                item?.map_order_meal_items
              )?.addonsPrice;
            }
          } else {
            let addOns = AddOnCalculate(item);
            itemPrice = (item?.price || 0) + (addOns?.addonsPrice || 0);
          }

          // console.log("itemPriceitemPrice", item, itemPrice)

          return (
            <>
              <div className="py-2 px-4">
                <div className="">
                  <div className="grid grid-cols-3">
                    <p className="md:text-lg textMd whitespace-normal font-bold ">
                      {item?.item_name} {ItemSizeNameForOrder(item)}
                    </p>
                    <div className="itemSize md:text-lg textMd font-bold text-center">
                      {item.quantity || 1}x
                    </div>
                    <div className="Price md:text-lg textMd font-bold text-right">
                      {ParseFloat(itemPrice * (item.quantity || 1))}
                    </div>
                  </div>
                  <div className="md:ml-3 ml-0">
                    {CheckIsMeal(item.is_meal) ? (
                      <>
                        {item?.map_order_meal_items?.map(
                          (mealItem: any, mealIndex: number) => {
                            return (
                              <>
                                <div
                                  key={mealIndex}
                                  className="flexBox justifyBetween mt-1"
                                >
                                  <div className="">
                                    <div className="flex items-center gap-2 md:text-lg textMd font-normal capitalize">
                                      {/* <i className="fa fa-circle text-[5px]"></i>{" "} */}
                                      {mealItem?.item_name}{" "}
                                      {orderMealItemVariationSize(mealItem)}
                                      <span className="text-gray-600">
                                        (
                                        {mealItem?.price
                                          ? ParseFloat(mealItem?.price)
                                          : t("Home.free")}
                                        )
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* {/ step option .... /} */}
                                {ReturnItemOptions(
                                  mealItem?.selected_step_options
                                )}
                                {/* @@ sub category */}
                                {ReturnItemSubCategory(
                                  mealItem?.selected_sub_categories
                                )}

                                {/* @@ add on data  */}
                                {ReturnAddOnData(mealItem.selected_add_ons)}
                              </>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <>
                        {/* {/ step option .... /} */}
                        {ReturnItemOptions(item?.order_item_step)}

                        {/* @@ sub category */}
                        {ReturnItemSubCategory(item?.order_item_sub_categories)}

                        {/* @@ add on data  */}
                        {ReturnAddOnData(item.addon_data)}
                      </>
                    )}
                    {item?.notes && (
                      <p>
                        <span className="font-bold">{t("MyOrders.notes")}:</span>{" "}
                        {item?.notes}
                      </p>
                    )}
                    {item?.order_note && (
                      <p>
                        <span className="font-bold"> {t("MyOrders.notes")}:</span>{" "}
                        {item?.order_note}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        })}
        <hr />
        <div className="flex justify-end gap-16 text-right py-2 px-4">
          <div className="md:text-lg textMd ">
            <DisplayParagraph label={t("MyOrders.itemTotal")} />
            <DisplayParagraph label={t("Checkout.serviceFee")} />
            {orderDetail?.order_category == 3 ? (<DisplayParagraph label={t("Checkout.deliveryFee")} />) : null}

            {orderDetail?.remaning_amount ? (<DisplayParagraph label={t("MyOrders.remainingAmount")} />) : ("")}

            {orderDetail?.total_tax ? (<DisplayParagraph label={t("MyOrders.taxes")} />) : ("")}

            {orderDetail?.discount > 0 && (
              <DisplayParagraph className="text-[#00A838]" label={t("MyOrders.discount")} />)}

            <DisplayParagraph label={t("CartDetails.platformFee")} />
               <DisplayParagraph label={t("CartDetails.round_total")} />
            <DisplayParagraph label={t("MyOrders.grandTotal")} />
          </div>

          <div className="md:text-lg textMd  ">
            <DisplayParagraph label={ParseFloat(orderDetail?.sub_total)} />
            <DisplayParagraph label={ParseFloat(orderDetail?.service_charge)} />

            {orderDetail?.order_category == 3 ? (
              <DisplayParagraph label={ParseFloat(orderDetail?.delivery_charges)} />) : null}

            {orderDetail?.remaning_amount ? (
              <DisplayParagraph label={ParseFloat(orderDetail?.remaning_amount)} />) : ("")}

            {orderDetail?.total_tax ? (<DisplayParagraph label={ParseFloat(orderDetail?.total_tax)} />) : ("")}

            {(orderDetail?.discount && orderDetail?.discount > 0) ? (
              <DisplayParagraph className="text-[#00A838]" label={ParseFloat(orderDetail?.discount)} />
            ) : ''}
            {/* <DisplayParagraph className="md:text-2xl text-lg font-bold" label={ParseFloat(orderDetail?.total_price)} /> */}
            <DisplayParagraph label={ParseFloat(orderDetail?.platform_fee || platformFee || 0)} />
            <DisplayParagraph label={ParseFloat(orderDetail?.round_off || platformFee || 0)} />

            <DisplayParagraph label={ParseFloat(orderDetail?.total_price)} />
          </div>
        </div>
      </div>
    </>
  );
}

const DisplayParagraph = (props: any) => {
  return (
    <p className={` font-normal ${props?.className}`}>{props?.label}</p>
  );
};
